import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MunicipalityState {
  message: string;
  error?: string;
  type?: 'success' | 'error';
}

const initialState: MunicipalityState = {
  message: '',
  error: '',
  type: 'error',
};

const infoMessageSlice = createSlice({
  name: 'infoMessage',
  initialState,
  reducers: {
    addMessage: (
      state,
      action: PayloadAction<{
        message: string;
        error?: string;
        type?: 'success' | 'error';
      }>
    ) => {
      state.message = action.payload.message;
      state.error = action.payload.error;
      state.type = action.payload.type || 'error';
    },
    removeMessage: (state) => {
      state.message = '';
      state.error = '';
    },
  },
});

export const { addMessage, removeMessage } = infoMessageSlice.actions;
export default infoMessageSlice.reducer;
